const routes = [
  {
    index: true,
    label: 'Leo Dong',
    path: '/',
  },
  // {
  //   label: 'About',
  //   path: '/about',
  // },
  {
    label: 'Resume',
    path: '/resume',
  },
  // {
  //   label: 'Projects',
  //   path: '/projects',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Photography',
    path: '/photography',
  },
  {
    label: 'Art',
    path: '/art',
  },
  {
    label: 'Blog',
    path: '/blog',
  },
  // {
  //   label: 'Contact',
  //   path: '/contact',
  // },
];

export default routes;
